const MANAGEMENT = 'Management';
const DOCUMENT_CONTROLLER = 'Document Controller';
const PROJECT_MANAGER = 'Project Manager';
const ENGINEER = 'Engineer';
const DRAUGHTSMAN = 'Draughtsman';
const DESIGN_MANAGER = 'Design Manager';
const QAQC_MANAGER = 'QAQC Manager';
const CONTRACT_MANAGER = 'Contract Manager';
const PLANNING_ENGINEER = 'Planning Engineer';
const QUANTITY_SURVEYOR = 'Quantity Surveyor';
const PROCUREMENT_MANAGER = 'Procurement Manager';
const HEALTH_SAFETY_ENVIRONMENT = 'Health Safety & Environment Officer';
const SITE_ENGINEER = 'Site Engineer';
const SITE_ADMINISTRATOR = 'Site Administrator';
const STAFF = 'Staff';
const SUPERVISOR = 'Supervisor';
const CONSULTANT_MANAGEMENT = 'Consultant Management';
const CONSULTANT_DRAUGHTSMAN = 'Consultant Draughtsman';
const CONSULTANT_DESIGN_MANAGER = 'Consultant Design Manager';
const CONSULTANT_DOCUMENT_CONTROLLER = 'Consultant Document Controller';
const CONSULTANT_PROJECT_MANAGER = 'Consultant Project Manager';
const CONSULTANT_ENGINEER = 'Consultant Engineer';
const CONSULTANT_QAQC_MANAGER = 'Consultant QAQC Manager';
const CONSULTANT_CONTRACT_MANAGER = 'Consultant Contract Manager';
const CONSULTANT_PLANNING_ENGINEER = 'Consultant Planning Engineer';
const CONSULTANT_QUANTITY_SURVEYOR = 'Consultant Quantity Surveyor';
const CONSULTANT_PURCHASING_MANAGER = 'Consultant Procurement Manager';
const CONSULTANT_HEALTH_SAFETY_ENVIRONMENT = 'Consultant Health Safety & Environment Officer';
const CONSULTANT_SITE_ENGINEER = 'Consultant Site Engineer';
const CONSULTANT_SITE_ADMINISTRATOR = 'Consultant Site Administrator';
const CONSULTANT_SUPERVISOR = 'Consultant Supervisor';
const CONSULTANT_STAFF = 'Consultant Staff';
const EMPLOYER_MANAGEMENT = 'Employer Management';
const EMPLOYER_DRAUGHTSMAN = 'Employer Draughtsman';
const EMPLOYER_DOCUMENT_CONTROLLER = 'Employer Document Controller';
const EMPLOYER_PROJECT_MANAGER = 'Employer Project Manager';
const EMPLOYER_ENGINEER = 'Employer Engineer';
const EMPLOYER_DESIGN_MANAGER = 'Employer Design Manager';
const EMPLOYER_QAQC_MANAGER = 'Employer QAQC Manager';
const EMPLOYER_CONTRACT_MANAGER = 'Employer Contract Manager';
const EMPLOYER_PLANNING_ENGINEER = 'Employer Planning Engineer';
const EMPLOYER_QUANTITY_SURVEYOR = 'Employer Quantity Surveyor';
const EMPLOYER_PROCUREMENT_MANAGER = 'Employer Procurement Manager';
const EMPLOYER_HEALTH_SAFETY_ENVIRONMENT = 'Employer Health Safety & Environment Officer';
const EMPLOYER_SITE_ENGINEER = 'Employer Site Engineer';
const EMPLOYER_SUPERVISOR = 'Employer Supervisor';
const EMPLOYER_SITE_ADMINISTRATION = 'Employer Site Administrator';
const EMPLOYER_STAFF = 'Employer Staff';
const SUBCONTRACTOR_DOCUMENT_CONTROLLER = 'Subcontractor Document Controller';
 
module.exports = {
  MANAGEMENT,
  DOCUMENT_CONTROLLER,
  PROJECT_MANAGER,
  ENGINEER,
  DRAUGHTSMAN,
  DESIGN_MANAGER,
  QAQC_MANAGER,
  CONTRACT_MANAGER,
  PLANNING_ENGINEER,
  QUANTITY_SURVEYOR,
  PROCUREMENT_MANAGER,
  HEALTH_SAFETY_ENVIRONMENT,
  SITE_ENGINEER,
  SITE_ADMINISTRATOR,
  SUPERVISOR,
  STAFF,
  CONSULTANT_MANAGEMENT,
  CONSULTANT_DRAUGHTSMAN,
  CONSULTANT_DESIGN_MANAGER,
  CONSULTANT_DOCUMENT_CONTROLLER,
  CONSULTANT_PROJECT_MANAGER,
  CONSULTANT_ENGINEER,
  CONSULTANT_QAQC_MANAGER,
  CONSULTANT_CONTRACT_MANAGER,
  CONSULTANT_PLANNING_ENGINEER,
  CONSULTANT_QUANTITY_SURVEYOR,
  CONSULTANT_PURCHASING_MANAGER,
  CONSULTANT_HEALTH_SAFETY_ENVIRONMENT,
  CONSULTANT_SITE_ENGINEER,
  CONSULTANT_SITE_ADMINISTRATOR,
  CONSULTANT_SUPERVISOR,
  CONSULTANT_STAFF,
  EMPLOYER_MANAGEMENT,
  EMPLOYER_DRAUGHTSMAN,
  EMPLOYER_DOCUMENT_CONTROLLER,
  EMPLOYER_PROJECT_MANAGER,
  EMPLOYER_ENGINEER,
  EMPLOYER_DESIGN_MANAGER,
  EMPLOYER_QAQC_MANAGER,
  EMPLOYER_CONTRACT_MANAGER,
  EMPLOYER_PLANNING_ENGINEER,
  EMPLOYER_QUANTITY_SURVEYOR,
  EMPLOYER_PROCUREMENT_MANAGER,
  EMPLOYER_HEALTH_SAFETY_ENVIRONMENT,
  EMPLOYER_SITE_ENGINEER,
  EMPLOYER_SUPERVISOR,
  EMPLOYER_SITE_ADMINISTRATION,
  EMPLOYER_STAFF,
  SUBCONTRACTOR_DOCUMENT_CONTROLLER
};